import React, {useCallback, useEffect} from "react";
import styled from "styled-components";

import {useHistory} from "react-router-dom";
import {Spinner} from "@chakra-ui/react";
import useAtBottom from "../utils/use_at_bottom";
import {themecolors} from "../utils/themecolors";
import {useStoreProfile} from "../store";
import CommentActions from "./comment_actions";
import ScrollToTop from "./scroll_to_top";
import Virtualize from "./virtualize";
import Comment2 from "./comment2";

const SpinnerContainer = styled.div`
  text-align: center;
  padding: 48px 0;
`;

const CommentList = styled(({className, comments, loading, loadNextPage, feedKey, profile}) => {

    const {theme} = useStoreProfile();
    const scrollToTop = useCallback(() => {
        document.scrollingElement.scrollTop = 0;
    }, []);
    useEffect(scrollToTop, [scrollToTop, feedKey]);
    const detector = useAtBottom(!loading && loadNextPage);

    const history = useHistory();
    const handleSubthread = (comment) => {
        if (profile) {
            history.push(`/p/${comment.post_uuid}/x/c/${comment.uuid}/`);
        }
    };

    return (<>
        {loading &&
            <SpinnerContainer>
                <Spinner
                    thickness='4px'
                    speed='0.65s'
                    emptyColor={theme === "dark" ? themecolors.dark_background_5 : themecolors.light_low_impact_text}
                    color={theme === "dark" ? themecolors.dark_background_2 : themecolors.pure_white}
                    size='lg'
                />
            </SpinnerContainer>
        }
        <Virtualize
            key={feedKey}
            className={className}
            items={comments}
            keyOfItem={(item, index) => item?.uuid || index}
            renderItem={(comment) => (
                <div onClick={() => handleSubthread(comment)}>
                    <Comment2
                        key={comment.id}
                        comment={comment}
                        contextual
                        profile={profile}
                    />
                </div>
            )}
        />
        {!loading && detector}
        <ScrollToTop onClick={scrollToTop}/>
    </>);
})`
  height: 100%;
  margin-bottom: 56px;
`;

export default CommentList;
